export const LOGIN = 'LOGIN'
export const SCHOOLLIST = 'SCHOOLLIST'
export const GETINFO = 'GETINFO'
export const LOGOUT = 'LOGOUT'
// 查询所有的省市区数据
export const GETREGION = 'GETREGION'
// 标签
export const CLOSECURRENTTAG = 'CLOSECURRENTTAG'
export const SETDATACENTERPERMIS = 'SETDATACENTERPERMIS'



// WEBPACK FOOTER //
// ./src/store/user/types.js